import { importBootstrap5 } from "@cervval.js/client-html5-ui/src/lookAndFeel/bootstrap5";
import { importFontAwesome6 } from "@cervval.js/client-html5-ui/src/lookAndFeel/fontAwesome6";
import "../../assets/global.dom.scss"; // *.dom.scss files are injected in html by style-loader

/**
 * Ensures the styles and libs above are imported
 */
export function setupApplicationLookAndFeel(): void {
    importFontAwesome6();
    importBootstrap5();
}